import {
  ChakraFlex,
  Counter,
  FAIconName,
  FireflyButton,
  Text,
} from '@equip.health/ui';
import { CareTeamTranslations } from '~/lib/constants/careTeam.constants';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import { PatientEvents } from '~/analytics/patientEvents';

interface CareTeamHeaderV2Props {
  id: string;
  isDisabled: boolean;
  onEdit: () => void;
  count?: number;
  isLoading: boolean;
  patientId?: string;
}

const CareTeamHeader = ({
  id,
  isDisabled,
  onEdit,
  count,
  isLoading,
  patientId,
}: CareTeamHeaderV2Props) => {
  const showCounter = count && count > 0;
  const { trackEvent } = useAnalytics();
  const hasCareTeamRecords = !!count && count > 0;
  return (
    <ChakraFlex id={`${id}-header`} justify="space-between" width="100%">
      <ChakraFlex alignItems="center">
        <Text marginRight="16px" variant="h5">
          {CareTeamTranslations.PROVIDER_TEAM}
        </Text>
        {showCounter ? <Counter id={`${id}__counter`} number={count} /> : null}
      </ChakraFlex>
      <FireflyButton
        id={`${id}-edit-button`}
        isDisabled={isDisabled}
        isLoading={isLoading}
        leftIcon={FAIconName.penRegular}
        onClick={() => {
          trackEvent(
            hasCareTeamRecords
              ? PatientEvents.providerAssignmentEditTeamButtonClicked
              : PatientEvents.providerAssignmentAddTeamButtonClicked,
            {
              patientId,
              source: AnalyticsSourceValues.CARE_PLAN_TAB,
            },
          );
          onEdit();
        }}
        size="small"
        variant="secondary"
      >
        {hasCareTeamRecords
          ? CareTeamTranslations.EDIT_TEAM
          : CareTeamTranslations.ADD_TEAM}
      </FireflyButton>
    </ChakraFlex>
  );
};

export default CareTeamHeader;
